import axios from 'axios';
import { parcoursPourRequete } from './parcoursActif';

const API_URL = import.meta.env.VITE_API_URL || '/backend/api';

const api = axios.create({
    baseURL: API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
});

// Injecter le token JWT dans chaque requete
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('monquiz_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Joindre le parcours actif aux requetes qui tirent des questions a l'echelle
// d'une thematique. Sans cela, le catalogue affiche un concours mais le melange,
// le quiz intelligent, les revisions et les QRC piochent dans toute la thematique.
// L'ajout n'a lieu que si la requete vise la thematique effectivement consultee ;
// la liste des points d'entree concernes est dans services/parcoursActif.js.
api.interceptors.request.use((config) => {
    const url = config.url || '';
    const cible = config.method === 'get' ? (config.params || {}) : (config.data || {});
    const slug = parcoursPourRequete(url, cible);
    if (!slug) return config;
    if (url.includes('?')) {
        // Chaîne de requête écrite à la main dans l'URL : on y ajoute le paramètre.
        config.url = `${url}&parcours=${encodeURIComponent(slug)}`;
    } else if (config.method === 'get') {
        config.params = { ...(config.params || {}), parcours: slug };
    } else if (config.data && typeof config.data === 'object') {
        config.data = { ...config.data, parcours: slug };
    }
    return config;
});

// Gerer les 401 (token expire/invalide, session remplacee ou revoquee)
// et le 403 'gate_required' (portail admin).
api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;
        const reason = error.response?.data?.reason;
        if (status === 401) {
            if (reason === 'session_replaced') {
                // Double connexion detectee
                localStorage.removeItem('monquiz_token');
                localStorage.removeItem('monquiz_user');
                window.dispatchEvent(new CustomEvent('monquiz:session_replaced'));
            } else {
                // Token expire/invalide ou session revoquee (token_version)
                localStorage.removeItem('monquiz_token');
                localStorage.removeItem('monquiz_user');
                window.dispatchEvent(new CustomEvent('monquiz:auth_expired'));
            }
        } else if (status === 403 && reason === 'gate_required') {
            // Portail admin : 2e mot de passe requis pour l'espace de gestion.
            window.dispatchEvent(new CustomEvent('monquiz:admin_gate_required'));
        }
        return Promise.reject(error);
    }
);

export default api;
